<template>
  <div class="delete-confirm-container" @click.stop>
    <div class="close-icon" @click="$emit('close')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" style="transform:rotate(45deg);position:relative;top:4px;"><g fill="none"><g style="stroke-width:3;stroke:#F7103C"><path d="M8 8L8-1 8 8 -1 8 8 8ZM8 8L17 8 8 8 8 17 8 8Z"/></g></g></svg>
    </div>
    <div class="header">Delete Project</div>
    <div class="description">
      Type "delete" to confirm the permanent deletion of project "{{ projectName }}".<br/>
    </div>
    <div class="fields">
      <input type="text" class="input" v-model="confirmation"/>
    </div>
    <div class="delete-button" @click="deleteProject()" :disabled="!confirmed" :class="{ disabled : !confirmed }">
      Delete <i v-if="inProgress" class="fa fa-circle-notch fa-spin"/>
    </div>
    <div class="warning">
      This cannot be undone!
    </div>
  </div>
</template>

<script>
import projectService from '@/services/project-service.js'

export default {
  name: 'DeleteConfirm',
  props: {
    projectName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      confirmation: '',

      inProgress: false,
      err: null,
    }
  },
  methods: {
    async deleteProject() {
      if(this.inProgress || !this.confirmed) {
        return
      }
      this.inProgress = true
      await projectService.deleteProject(this.projectName)
      this.$store.commit('mutate', { prop: 'projects', value: [] })
      this.$router.push('/')
      // send delete request
      // update projects in store
      // redirect to project list
    }
  },
  computed: {
    confirmed() {
      return this.confirmation.toLowerCase() == 'delete'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.delete-confirm-container {
  padding: 50px;
  text-align: left;
  border-radius: $border-radius;
  position: relative;

  .header {
    margin-bottom: 30px;
    font-size: 20px;
  }

  .fields {
    input {
      margin: 10px 0px;
      border-radius: $border-radius;
    }
  }

  .delete-button {
    margin-top: 50px;
    padding: 20px 30px;
    background-color: $primary;
    border-radius: $border-radius;
    color: white;
    text-align: center;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      box-shadow: 2px 2px 10px rgba(black, 0.4);
    }

  }
  .disabled {
    background-color: $secondaryText;
    cursor: not-allowed;
  }

  .close-icon {
    position: absolute;
    top: -16px;
    right: -16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 2px 2px 10px rgba(black, 0.4);
    text-align: center;
    cursor: pointer;
  }
}
.warning {
  text-align: right;
  margin-top: 10px;
}
</style>